import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, Menu, X } from "lucide-react";
import "./Navbar.css";
import PMLogo from "../../assets/punjimitra-icon-2.png";
import { NAV_LINKS } from "../../data/content";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileMoreOpen, setMobileMoreOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setOpenDropdown(null);
    setMobileMoreOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const renderDesktopItem = (item) => {
    if (item.children) {
      const trigger = item.to ? (
        <Link to={item.to} className="poonjim-navbar-link">
          <span className="label">
            {item.label}
            <ChevronDown size={14} className="poonjim-nav-chevron" />
          </span>
        </Link>
      ) : (
        <button
          type="button"
          className="poonjim-navbar-link poonjim-navbar-link--btn"
        >
          <span className="label">
            {item.label}
            <ChevronDown size={14} className="poonjim-nav-chevron" />
          </span>
        </button>
      );

      return (
        <div
          key={item.label}
          className={`poonjim-nav-dropdown ${
            !item.to || item.label === "More" ? "poonjim-nav-dropdown--end" : ""
          } ${openDropdown === item.label ? "is-open" : ""}`}
          onMouseEnter={() => setOpenDropdown(item.label)}
          onMouseLeave={() => setOpenDropdown(null)}
        >
          {trigger}
          <div className="poonjim-nav-dropdown-menu">
            {item.children.map((child) => (
              <Link key={child.to} to={child.to}>
                {child.label}
              </Link>
            ))}
          </div>
        </div>
      );
    }

    return (
      <Link key={item.to} to={item.to} className="poonjim-navbar-link">
        <span className="label">{item.label}</span>
      </Link>
    );
  };

  return (
    <>
      <div className="pm-topbar">
        <div className="pm-container pm-topbar-inner">
          <div>
            AMFI / ARN registered · <b>Kanchan Gupta — ARN 175447</b>
          </div>
          <div className="pm-topbar-contact">
            <a href="tel:+919784862667">+91 97848 62667</a>
            &nbsp;·&nbsp;
            <a href="mailto:nikhil.gupta@poonjimitra.com">
              nikhil.gupta@poonjimitra.com
            </a>
          </div>
        </div>
      </div>

      <header className="poonjim-navbar">
        <div className="poonjim-navbar-container">
          <Link to="/" className="poonjim-navbar-logo">
            <img
              src={PMLogo}
              alt="Poonji Mitra"
              className="poonjim-navbar-logo-image"
            />
            <span className="poonjim-navbar-logo-text">
              Poonji<span>Mitra</span>
            </span>
          </Link>

          <nav className="poonjim-navbar-links" aria-label="Primary">
            {NAV_LINKS.map(renderDesktopItem)}
          </nav>

          <div className="poonjim-navbar-actions">
            <Link
              to="/portfolio-review"
              className="poonjim-navbar-btn poonjim-navbar-btn-outline"
            >
              Portfolio Review
            </Link>
            <Link
              to="/contact"
              className="poonjim-navbar-btn poonjim-navbar-btn-primary"
            >
              Book Free Call
            </Link>
          </div>

          <button
            className="poonjim-navbar-hamburger"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {menuOpen && (
          <div className="poonjim-navbar-mobile-menu">
            {NAV_LINKS.map((item) => {
              if (item.children && !item.to) {
                return (
                  <div key={item.label} className="poonjim-mobile-group">
                    <button
                      type="button"
                      className="poonjim-navbar-mobile-link poonjim-mobile-more-toggle"
                      onClick={() => setMobileMoreOpen((v) => !v)}
                      aria-expanded={mobileMoreOpen}
                    >
                      {item.label}
                      <ChevronDown
                        size={16}
                        className={mobileMoreOpen ? "is-open" : ""}
                      />
                    </button>
                    {mobileMoreOpen &&
                      item.children.map((child) => (
                        <Link
                          key={child.to}
                          to={child.to}
                          className="poonjim-navbar-mobile-sublink"
                          onClick={() => setMenuOpen(false)}
                        >
                          {child.label}
                        </Link>
                      ))}
                  </div>
                );
              }

              return (
                <div key={item.label} className="poonjim-mobile-group">
                  <Link
                    to={item.to}
                    className="poonjim-navbar-mobile-link"
                    onClick={() => setMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                  {item.children?.map((child) => (
                    <Link
                      key={child.to}
                      to={child.to}
                      className="poonjim-navbar-mobile-sublink"
                      onClick={() => setMenuOpen(false)}
                    >
                      {child.label}
                    </Link>
                  ))}
                </div>
              );
            })}
            <Link
              to="/contact"
              className="poonjim-navbar-btn poonjim-navbar-btn-primary"
              onClick={() => setMenuOpen(false)}
            >
              Book Free Call
            </Link>
            <a
              className="poonjim-navbar-btn poonjim-navbar-btn-outline"
              href="https://portal.poonjimitra.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Login / Sign Up
            </a>
          </div>
        )}
      </header>
    </>
  );
};

export default Navbar;
